import { Skeleton, Typography } from "antd";
import {
  StyledAppsContainerSidebarMenu,
  StyledAppsContainerSidebarMenuContainer,
} from "./index.styled";
import { useSidebar } from "@lib/context/SidebarContext";
import { AppTabProps } from "../../AppTabs";
import { FormattedMessage } from "react-intl";

type Props = {
  loading: boolean;
  onClick: (key: string) => void;
  activeKey?: string;
  defaultActiveKey?: string;
  data: AppTabProps[];
  minWidth?: string;
  maxWidth?: string;
  title?: string | React.ReactNode;
};

export default function AppsContainerSidebarMenu(props: Props) {
  const {
    data,
    loading,
    onClick,
    activeKey,
    defaultActiveKey,
    minWidth,
    maxWidth,
    title = <FormattedMessage id="common.menu" />,
  } = props;
  const { collapsed } = useSidebar();

  return (
    <StyledAppsContainerSidebarMenuContainer
      collapsed={collapsed}
      minWidth={minWidth}
      maxWidth={maxWidth}
      title={title}
    >
      {loading ? (
        <Skeleton active />
      ) : (
        <StyledAppsContainerSidebarMenu
          collapsed={collapsed}
          activeKey={activeKey}
          defaultActiveKey={defaultActiveKey}
          tabPosition="left"
          onChange={onClick}
          items={data.map((item) => ({
            ...item,
            icon: item.Icon,
            label: <Typography.Text>{item.Title}</Typography.Text>,
          }))}
          minWidth={minWidth}
          maxWidth={maxWidth}
        />
      )}
    </StyledAppsContainerSidebarMenuContainer>
  );
}
